// src/modules/config/components/MenuItemModal/RecipesTab.tsx
import React from 'react';
import { Form, Input, Row, Col, Card, Progress } from 'antd';
import { MenuItem } from '@/types';

const { TextArea } = Input;

interface RecipesTabProps {
  isEdit: boolean;
  menuItem: MenuItem | null;
}

export const RecipesTab: React.FC<RecipesTabProps> = ({ isEdit, menuItem }) => {
  
  // Функция для вычисления полноты заполнения
  const calculateCompleteness = (language: 'ru' | 'kz' | 'en') => {
    if (!menuItem) return 0;
    
    const fields = [
      language === 'ru' ? 'name' : language === 'kz' ? 'name_kz' : 'name_en',
      language === 'ru' ? 'description' : language === 'kz' ? 'description_kz' : 'description_en', 
      language === 'ru' ? 'composition' : language === 'kz' ? 'composition_kz' : 'composition_en',
      language === 'ru' ? 'recipe' : language === 'kz' ? 'recipe_kz' : 'recipe_en',
      language === 'ru' ? 'storage_instructions' : language === 'kz' ? 'storage_instructions_kz' : 'storage_instructions_en',
      language === 'ru' ? 'cooking_instructions' : language === 'kz' ? 'cooking_instructions_kz' : 'cooking_instructions_en'
    ];
    
    const filledFields = fields.filter(field => {
      const value = (menuItem as any)[field];
      return value && value.trim().length > 0;
    }).length;
    
    return Math.round((filledFields / fields.length) * 100);
  };

  return (
    <div>
      {/* Способ приготовления */}
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="recipe"
            label="Способ приготовления (русский)"
          >
            <TextArea 
              rows={6} 
              placeholder="Подробный способ приготовления на русском языке" 
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="recipe_kz"
            label="Способ приготовления (казахский)"
          >
            <TextArea 
              rows={6} 
              placeholder="Подробный способ приготовления на казахском языке" 
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="recipe_en"
            label="Способ приготовления (английский)"
          >
            <TextArea 
              rows={6} 
              placeholder="Detailed cooking method in English" 
            />
          </Form.Item>
        </Col>
      </Row>

      {/* Инструкции по хранению */}
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="storage_instructions"
            label="Условия хранения (русский)"
          >
            <TextArea 
              rows={4} 
              placeholder="Инструкции по хранению блюда на русском языке" 
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="storage_instructions_kz"
            label="Условия хранения (казахский)"
          >
            <TextArea 
              rows={4} 
              placeholder="Инструкции по хранению блюда на казахском языке" 
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="storage_instructions_en"
            label="Условия хранения (английский)"
          >
            <TextArea 
              rows={4} 
              placeholder="Storage instructions in English" 
            />
          </Form.Item>
        </Col>
      </Row>

      {/* Инструкции по сервировке */}
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="cooking_instructions"
            label="Варианты сервировки (русский)"
          >
            <TextArea 
              rows={4} 
              placeholder="Инструкции по сервировке на русском языке" 
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="cooking_instructions_kz"
            label="Варианты сервировки (казахский)"
          >
            <TextArea 
              rows={4} 
              placeholder="Инструкции по сервировке на казахском языке" 
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="cooking_instructions_en"
            label="Варианты сервировки (английский)"
          >
            <TextArea 
              rows={4} 
              placeholder="Serving instructions in English" 
            />
          </Form.Item>
        </Col>
      </Row>

      {/* Полнота заполнения */}
      {isEdit && menuItem && (
        <Card size="small" title="Полнота заполнения информации">
          <Row gutter={16}>
            <Col span={8}>
              <div style={{ marginBottom: 8 }}>
                <span>Русский язык:</span>
                <Progress 
                  percent={calculateCompleteness('ru')} 
                  size="small"
                  status={calculateCompleteness('ru') === 100 ? 'success' : 'active'}
                />
              </div>
            </Col>
            <Col span={8}>
              <div style={{ marginBottom: 8 }}>
                <span>Казахский язык:</span>
                <Progress 
                  percent={calculateCompleteness('kz')} 
                  size="small"
                  status={calculateCompleteness('kz') === 100 ? 'success' : 'active'}
                />
              </div>
            </Col>
            <Col span={8}>
              <div style={{ marginBottom: 8 }}>
                <span>Английский язык:</span>
                <Progress 
                  percent={calculateCompleteness('en')} 
                  size="small"
                  status={calculateCompleteness('en') === 100 ? 'success' : 'active'}
                />
              </div>
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );
};